import { render, staticRenderFns } from "./Pessoa.vue?vue&type=template&id=26529e4e&"
import script from "./Pessoa.vue?vue&type=script&lang=js&"
export * from "./Pessoa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports